














import { Vue, Component } from 'vue-property-decorator';
import { Loading, Toast } from 'vant';
import * as config from './config';
Vue.use(Loading);
@Component({
  components: {},
})
export default class Start extends Vue {
  loading: boolean = true;

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  handleClickUpload(val: string) {
    this.$router.push({
      path: val,
    });
  }
}
